export enum AnswerType {
  Yes = "YES",
  No = "NO",
  A = "A",
  B = "B",
  C = "C",
  D = "D",
  E = "E",
  None = "NONE",
  NotApplicable = "NOT_APPLICABLE"
}

export enum MultipleChoiceAnswerType {
  A = "A",
  B = "B",
  C = "C",
  D = "D",
  E = "E",
  None = "NONE",
  NotApplicable = "NOT_APPLICABLE"
}

export enum YesNoAnswerType {
  Yes = "YES",
  No = "NO",
}